import {bool, string} from 'prop-types'
import {useFormContext} from "react-hook-form";
import {Box, Switch, Text} from "theme-ui";
import React from "react";


function SwitchField({label, name, disabled = false,  ...rest}) {
  const {register} = useFormContext()
  return (
      <>
        {label ? (
          <Box><Text variant="switch">{label}</Text></Box>
        ) : null}
        <Box>
            <Switch
                disabled={disabled}
                variant={disabled ? 'disabled' : null}
                readOnly={disabled}
                {...register(name)}
                {...rest}
            />
        </Box>
      </>
  );
}

SwitchField.propTypes = {
  label: string,
  name: string,
    disabled: bool
}

export default SwitchField
